export default __webpack_public_path__ + "static/media/manaub.721b81d1.svg";